/**
 * Mensajes de error de Packs de Energía (US-2.4).
 *
 * El backend responde con el contrato uniforme del ADR 0021 (400 validación,
 * 403 permisos, 404 inexistente). Traducimos esos casos a mensajes accionables en
 * español sin ocultar el detalle del backend cuando aporta contexto.
 */
import { ApiError } from '@/lib/http/apiClient';

/** Traduce un error de la API de packs; el fallback cubre fallos no-HTTP. */
export function packErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    if (error.status === 400) {
      return error.message || 'Revisa los datos del pack e inténtalo de nuevo.';
    }
    if (error.status === 403) {
      return 'No tienes permisos para esta acción. Solo un SUPER_ADMIN puede gestionar packs.';
    }
    if (error.status === 404) {
      return 'El pack indicado no existe o fue eliminado.';
    }
    return error.message || fallback;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}
